// ShubhSamay — central, easy-to-edit configuration.
// Update WHATSAPP_NUMBER once the business WhatsApp line is live.

export const SUPPORT_EMAIL = "shubhsamayhq@gmail.com";

// Official WhatsApp business number (country code + number, no +, no spaces).
export const WHATSAPP_NUMBER = "918817986468";
export const WHATSAPP_DISPLAY = "+91 88179 86468";

export const WHATSAPP_PREFILL =
  "Hi ShubhSamay! I'd like to start receiving my personalized daily guidance on WhatsApp.";

export function getWhatsAppLink() {
  if (!WHATSAPP_NUMBER) return null;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_PREFILL)}`;
}

export const SOCIAL_LINKS = {
  instagram: "#",
  facebook: "#",
  youtube: "#",
  whatsapp: getWhatsAppLink(),
  email: `mailto:${SUPPORT_EMAIL}`,
};

export const PRICING = {
  monthly: { amount: "₹299", period: "/month" },
  annual: { original: "₹3,588", amount: "₹2,699", period: "/year", save: "₹889" },
};
